import _extends from "@babel/runtime/helpers/esm/extends";

/**
 * @file 帮助提示
 * @author alfielv
 */
import React, { useCallback } from 'react';
import { OverlayTrigger, PopOver, Icon } from '@tencent/spaui';
import './index.css';

var Helptip = function Helptip(props) {
  var content = props.content,
      overlayTriggerProps = props.overlayTriggerProps,
      popOverProps = props.popOverProps;
  var handlePopOverClick = useCallback(function (event) {
    event.preventDefault();
    event.stopPropagation();
  }, []);
  return /*#__PURE__*/React.createElement(OverlayTrigger, _extends({
    trigger: "hover",
    hideDelayTime: 0,
    alignment: "auto",
    placement: "top",
    autoResize: true,
    autoPlacementBasic: "window",
    overlay: /*#__PURE__*/React.createElement(PopOver, _extends({
      className: "helptip__popover",
      style: {
        // FIXME popover对不齐，没什么好办法，先固定写死width
        width: 140
      }
    }, popOverProps), /*#__PURE__*/React.createElement("div", {
      onClick: handlePopOverClick
    }, content))
  }, overlayTriggerProps), /*#__PURE__*/React.createElement("span", {
    className: "helptip"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "question-filled",
    width: "14",
    height: "14",
    color: "rgba(104, 119, 156, .3)"
  })));
};

export default Helptip;